export const ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
    ADMIN_LOGIN: "/auth/admin/login",
    REFRESH_TOKENS: "/auth/refresh-tokens",
    LOGOUT: "/auth/logout",
    SIGNUP: "/auth/signup",
    ACCOUNT: "/auth/account",
    UPDATE_ACCOUNT: "/auth/account",
    CHANGE_PASSWORD: "/auth/change-password",
  },

  TOURS: {
    STAYS: "/tours/stays",
    FLIGHTS: "/tours/flights",
    TRAVEL_ASSISTANTS: "/tours/travel-assistants",
  },

  WAITLIST: {
    CREATE: "/waitlist",
  },

  PROVIDERS: {
    PROFILE: "/providers/profile",
    LICENSE: "/providers/profile/license",
    ID_DOCUMENT: "/providers/profile/id-document",
    SUBMIT_REVIEW: "/providers/profile/submit-review",
    AVAILABILITY: "/providers/profile/availability",
    VEHICLE: "/providers/profile/vehicle",
    PAYMENT: "/providers/profile/payment",
    BANKS: "/providers/banks",
    BANK_RESOLVE: "/providers/banks/resolve",
    BANK_ACCOUNTS: "/providers/bank-accounts",
    WITHDRAWALS: "/providers/withdrawals",
    EXPERTISE: "/providers/profile/expertise",
  },

  MESSAGES: {
    CONVERSATIONS: "/messages/conversations",
    SEND: "/messages",
    UNREAD_COUNT: "/messages/unread-count",
  },

  NOTIFICATIONS: {
    FEED: "/notifications",
    UNREAD_COUNT: "/notifications/unread-count",
    READ_ALL: "/notifications/read-all",
  },

  ASSISTANTS: {
    LIST: "/assistants",
    DETAIL: "/assistants",
    RELATED: "/assistants",
    AVAILABILITY: "/assistants",
  },

  BOOKING: {
    LIST: "/bookings",
    MINE: "/bookings/mine",
    PAYSTACK_INIT: "/bookings/paystack/init",
    BANK_TRANSFER_INIT: "/bookings/bank-transfer/init",
    PAYSTACK_VERIFY: "/bookings/paystack/verify",
    DETAIL: "/bookings",
    ACTIONS: "/bookings",
  },

  // Admin endpoints - add new admin endpoints here
  ADMIN: {
    DASHBOARD_OVERVIEW: "/admin/dashboard/overview",
    DASHBOARD_REVENUE_PERFORMANCE: "/admin/dashboard/revenue-performance",
    DASHBOARD_FINANCIAL_SUMMARY: "/admin/dashboard/financial-summary",
    DASHBOARD_REVENUE_TRENDS: "/admin/dashboard/revenue-trends",
    DASHBOARD_TRANSACTIONS: "/admin/dashboard/transactions",
    WITHDRAWALS: "/admin/withdrawals",
    WITHDRAWAL_ACTION: "/admin/withdrawals",
    REFUNDS: "/admin/refunds",
    REFUND_ACTION: "/admin/refunds",
    DASHBOARD_PROVIDERS: "/admin/dashboard/providers",
    DASHBOARD_PROVIDERS_OVERVIEW: "/admin/dashboard/providers-overview",
    DASHBOARD_PROVIDERS_DIRECTORY: "/admin/dashboard/providers-directory",
    DASHBOARD_PROVIDER_DETAIL: "/admin/dashboard/providers",
    DASHBOARD_PROVIDERS_INSIGHTS_DOWNLOAD:
      "/admin/dashboard/providers-insights/download",
    DASHBOARD_REPORT_DOWNLOAD: "/admin/dashboard/report/download",
    DASHBOARD_STATS: "/admin/dashboard/stats",
    DASHBOARD_REVENUE: "/admin/dashboard/revenue",
    DASHBOARD_URGENT: "/admin/dashboard/urgent",
    ASSISTANTS: "/admin/assistants",
    BOOKINGS: "/admin/bookings",
    PROVIDERS_REVIEW: "/admin/providers",
    USERS: "/admin/users",
    USERS_DETAIL: "/admin/users",
    USERS_SUSPEND: "/admin/users",
    USERS_UNSUSPEND: "/admin/users",
    ACCOMMODATIONS: "/admin/accommodations",
    RIDES: "/admin/rides",
    FINANCES_REPORTS: "/admin/finances/reports",
    REPORTS: "/admin/reports",
    SETTINGS: "/admin/settings",
    SETTINGS_LOGO: "/admin/settings/logo",
  },

  UPLOADS: {
    SIGNATURE: "/uploads/signature",
  },
};
